export default {"src":"/_next/static/media/ExternalBenefitSelectIcon.6186e6f7.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};